document.documentElement.classList.remove('no-js')

function updateBlankBase(section) {
  const product = section?.querySelector('[data-blank-product].is-active')
  const side = section?.querySelector('[data-blank-side].is-active')?.dataset.blankSide || 'front'
  const image = section?.querySelector('[data-blank-base]')
  const fallback = section?.querySelector('[data-blank-fallback]')
  if (!product || !image || !fallback) return

  const front = product.dataset.frontImage || ''
  const back = product.dataset.backImage || ''
  const source = side === 'back' ? (back || front) : front

  if (source) {
    image.src = source
    image.alt = `${product.dataset.blankProduct} ${side} mockup`
    image.hidden = false
    fallback.hidden = true
  } else {
    image.removeAttribute('src')
    image.alt = ''
    image.hidden = true
    fallback.hidden = false
  }
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.site-header__toggle')
  if (toggle) {
    const menu = document.getElementById(toggle.getAttribute('aria-controls'))
    const open = toggle.getAttribute('aria-expanded') === 'true'
    toggle.setAttribute('aria-expanded', String(!open))
    menu?.classList.toggle('is-open', !open)
  }

  const choice = event.target.closest('[data-choice]')
  if (choice) {
    choice.parentElement?.querySelectorAll('[data-choice]').forEach((item) => item.classList.remove('is-active'))
    choice.classList.add('is-active')
    if (choice.dataset.colour) {
      const fill = choice.closest('[data-blank-builder-section]')?.querySelector('[data-garment-fill]')
      if (fill) fill.setAttribute('fill', choice.dataset.colour)
    }
    if (choice.dataset.blankSide) updateBlankBase(choice.closest('[data-blank-builder-section]'))
  }

  const product = event.target.closest('[data-blank-product]')
  if (product) {
    product.parentElement?.querySelectorAll('[data-blank-product]').forEach((item) => item.classList.remove('is-active'))
    product.classList.add('is-active')
    const section = product.closest('[data-blank-builder-section]')
    const name = section?.querySelector('[data-selected-blank]')
    if (name) name.textContent = product.dataset.blankProduct
    updateBlankBase(section)
    const shape = section?.querySelector('[data-garment-shape]')
    if (shape && window.gsap) window.gsap.fromTo(shape, { opacity: 0.35, scale: 0.94 }, { opacity: 1, scale: 1, duration: 0.45, ease: 'power2.out' })
  }

  const craftButton = event.target.closest('[data-craft-prev], [data-craft-next]')
  if (craftButton) {
    const section = craftButton.closest('#craft')
    const track = section?.querySelector('[data-craft-track]')
    const card = track?.querySelector('.craft-card')
    if (track && card) {
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0
      const direction = craftButton.hasAttribute('data-craft-prev') ? -1 : 1
      track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' })
    }
  }
})

document.addEventListener('change', (event) => {
  const contactFile = event.target.closest('[data-contact-file]')
  if (contactFile) {
    const file = contactFile.files?.[0]
    const name = contactFile.closest('.contact-upload')?.querySelector('[data-contact-file-name]')
    if (file && file.size > 20 * 1024 * 1024) {
      contactFile.value = ''
      if (name) name.textContent = 'file exceeds 20 MB'
      return
    }
    if (name) name.textContent = file?.name || 'no file selected'
  }

  const input = event.target.closest('[data-artwork-upload]')
  if (!input || !input.files?.[0]) return
  const section = input.closest('[data-blank-builder-section]')
  const preview = section?.querySelector('[data-artwork-preview]')
  if (!preview) return
  if (preview.dataset.objectUrl) URL.revokeObjectURL(preview.dataset.objectUrl)
  const url = URL.createObjectURL(input.files[0])
  preview.src = url
  preview.dataset.objectUrl = url
  preview.hidden = false
})

document.querySelectorAll('[data-artwork-preview]').forEach((art) => {
  let drag = null
  art.addEventListener('pointerdown', (event) => {
    drag = { x: event.clientX, y: event.clientY, left: art.offsetLeft, top: art.offsetTop }
    art.setPointerCapture(event.pointerId)
  })
  art.addEventListener('pointermove', (event) => {
    if (!drag) return
    art.style.left = `${drag.left + event.clientX - drag.x}px`
    art.style.top = `${drag.top + event.clientY - drag.y}px`
    art.style.transform = 'none'
  })
  art.addEventListener('pointerup', () => { drag = null })
})

const craftVideoObserver = 'IntersectionObserver' in window
  ? new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.play().catch(() => {})
        else entry.target.pause()
      })
    }, { threshold: 0.45 })
  : null

function initialiseCraftVideos(root = document) {
  root.querySelectorAll('.craft-card__video:not([data-craft-observed])').forEach((video) => {
    video.dataset.craftObserved = 'true'
    video.muted = true
    if (craftVideoObserver) craftVideoObserver.observe(video)
  })
}

function initialiseCraftTracks(root = document) {
  root.querySelectorAll('[data-craft-track]:not([data-drag-ready])').forEach((track) => {
    track.dataset.dragReady = 'true'
    let drag = null
    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') return
      drag = { x: event.clientX, left: track.scrollLeft }
      track.setPointerCapture(event.pointerId)
    })
    track.addEventListener('pointermove', (event) => {
      if (!drag) return
      track.scrollLeft = drag.left - (event.clientX - drag.x)
    })
    track.addEventListener('pointerup', () => { drag = null })
    track.addEventListener('pointercancel', () => { drag = null })
  })
}

function initialiseCraftSection(root = document) {
  initialiseCraftVideos(root)
  initialiseCraftTracks(root)
}

initialiseCraftSection()
document.addEventListener('shopify:section:load', (event) => initialiseCraftSection(event.target))

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max)
}

function replaceInputFile(input, file) {
  if (!input || !file || typeof DataTransfer === 'undefined') return
  const transfer = new DataTransfer()
  transfer.items.add(file)
  input.files = transfer.files
}

async function removeSolidBackground(file) {
  const bitmap = await createImageBitmap(file)
  const maxSide = 1600
  const ratio = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height))
  const width = Math.max(1, Math.round(bitmap.width * ratio))
  const height = Math.max(1, Math.round(bitmap.height * ratio))
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const context = canvas.getContext('2d', { willReadFrequently: true })
  context.drawImage(bitmap, 0, 0, width, height)
  bitmap.close?.()

  const image = context.getImageData(0, 0, width, height)
  const pixels = image.data
  const corners = [
    0,
    (width - 1) * 4,
    (height - 1) * width * 4,
    ((height - 1) * width + width - 1) * 4
  ]
  const background = corners.reduce((colour, index) => {
    colour[0] += pixels[index]
    colour[1] += pixels[index + 1]
    colour[2] += pixels[index + 2]
    return colour
  }, [0, 0, 0]).map((channel) => channel / corners.length)

  const threshold = 46
  const feather = 34
  for (let index = 0; index < pixels.length; index += 4) {
    if (pixels[index + 3] === 0) continue
    const red = pixels[index] - background[0]
    const green = pixels[index + 1] - background[1]
    const blue = pixels[index + 2] - background[2]
    const distance = Math.sqrt(red * red + green * green + blue * blue)
    if (distance <= threshold) pixels[index + 3] = 0
    else if (distance < threshold + feather) {
      pixels[index + 3] = Math.round(pixels[index + 3] * ((distance - threshold) / feather))
    }
  }
  context.putImageData(image, 0, 0)

  const blob = await new Promise((resolve, reject) => {
    canvas.toBlob((result) => result ? resolve(result) : reject(new Error('Unable to process artwork')), 'image/png')
  })
  const name = `${file.name.replace(/\.[^.]+$/, '')}-transparent.png`
  return new File([blob], name, { type: 'image/png' })
}

function initialiseProductCustomizers(root = document) {
  root.querySelectorAll('[data-product-customizer]:not([data-customizer-ready])').forEach((section) => {
    section.dataset.customizerReady = 'true'
    const stage = section.querySelector('[data-customizer-stage]')
    const printArea = section.querySelector('[data-customizer-print-area]')
    const artwork = section.querySelector('[data-customizer-artwork]')
    const artworkImage = section.querySelector('[data-customizer-artwork-image]')
    const base = section.querySelector('[data-customizer-base]')
    const viewLabel = section.querySelector('[data-customizer-view-label]')
    const status = section.querySelector('[data-customizer-status]')
    const form = section.querySelector('[data-customizer-form]')
    const configuration = section.querySelector('[data-customizer-configuration]')
    if (!stage || !printArea || !artwork || !artworkImage || !form || !configuration) return

    const sides = {
      front: { x: 50, y: 42, width: 30, file: null, url: '' },
      back: { x: 50, y: 42, width: 30, file: null, url: '' }
    }
    let activeSide = 'front'
    let pointer = null

    const setStatus = (message) => { if (status) status.textContent = message }

    const renderArtwork = () => {
      const current = sides[activeSide]
      if (!current.url) {
        artwork.hidden = true
        artworkImage.removeAttribute('src')
        return
      }
      artwork.hidden = false
      artworkImage.src = current.url
      artwork.style.left = `${current.x}%`
      artwork.style.top = `${current.y}%`
      artwork.style.width = `${current.width}%`
    }

    const renderSide = () => {
      const source = activeSide === 'back' ? stage.dataset.backImage : stage.dataset.frontImage
      if (base && source) {
        base.src = source
        base.alt = `${section.dataset.productTitle || 'Product'} ${activeSide} mockup`
      }
      if (viewLabel) viewLabel.textContent = `${activeSide} view`
      section.querySelectorAll('[data-customizer-side]').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.customizerSide === activeSide)
      })
      section.querySelectorAll('[data-customizer-upload-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.customizerUploadPanel !== activeSide
      })
      renderArtwork()
      setStatus('')
    }

    const setArtwork = (side, file) => {
      const current = sides[side]
      if (current.url) URL.revokeObjectURL(current.url)
      current.file = file
      current.url = URL.createObjectURL(file)
      const input = section.querySelector(`[data-customizer-upload-side="${side}"]`)
      const label = input?.closest('.product-customizer__upload')?.querySelector('[data-customizer-file-label]')
      if (label) label.textContent = file.name
      if (side === activeSide) renderArtwork()
    }

    section.querySelectorAll('[data-customizer-side]').forEach((button) => {
      button.addEventListener('click', () => {
        activeSide = button.dataset.customizerSide || 'front'
        renderSide()
      })
    })

    section.querySelectorAll('[data-customizer-upload]').forEach((input) => {
      input.addEventListener('change', () => {
        const file = input.files?.[0]
        if (!file) return
        if (file.size > 20 * 1024 * 1024) {
          input.value = ''
          setStatus('Please upload an artwork file smaller than 20 MB.')
          return
        }
        setArtwork(input.dataset.customizerUploadSide || activeSide, file)
        setStatus('Artwork loaded. Drag it into position on the mockup.')
      })
    })

    section.querySelectorAll('[data-customizer-remove-bg]').forEach((button) => {
      button.addEventListener('click', async () => {
        const input = section.querySelector(`[data-customizer-upload-side="${activeSide}"]`)
        const file = sides[activeSide].file || input?.files?.[0]
        if (!file) {
          setStatus('Upload artwork before removing its background.')
          return
        }
        button.disabled = true
        setStatus('Removing the solid background in your browser…')
        try {
          const processed = await removeSolidBackground(file)
          replaceInputFile(input, processed)
          setArtwork(activeSide, processed)
          setStatus('Background removed. Best results come from a clean, solid background.')
        } catch (error) {
          setStatus('Background removal could not process this file. Try a PNG or JPG with a solid background.')
        } finally {
          button.disabled = false
        }
      })
    })

    section.querySelectorAll('input[name="properties[Technique]"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        section.querySelectorAll('.product-customizer__choice').forEach((label) => {
          label.classList.toggle('is-active', Boolean(label.querySelector('input:checked')))
        })
      })
    })

    artwork.addEventListener('pointerdown', (event) => {
      event.preventDefault()
      const current = sides[activeSide]
      pointer = {
        id: event.pointerId,
        mode: event.target.closest('[data-customizer-resize]') ? 'resize' : 'drag',
        startX: event.clientX,
        startY: event.clientY,
        x: current.x,
        y: current.y,
        width: current.width
      }
      artwork.setPointerCapture(event.pointerId)
    })

    artwork.addEventListener('pointermove', (event) => {
      if (!pointer || pointer.id !== event.pointerId) return
      const bounds = printArea.getBoundingClientRect()
      const current = sides[activeSide]
      const deltaX = ((event.clientX - pointer.startX) / bounds.width) * 100
      const deltaY = ((event.clientY - pointer.startY) / bounds.height) * 100
      if (pointer.mode === 'resize') current.width = clamp(pointer.width + deltaX * 2, 8, 86)
      else {
        current.x = clamp(pointer.x + deltaX, 0, 100)
        current.y = clamp(pointer.y + deltaY, 0, 100)
      }
      renderArtwork()
    })

    const endPointer = (event) => {
      if (!pointer || pointer.id !== event.pointerId) return
      pointer = null
    }
    artwork.addEventListener('pointerup', endPointer)
    artwork.addEventListener('pointercancel', endPointer)

    form.addEventListener('submit', () => {
      const technique = form.querySelector('input[name="properties[Technique]"]:checked')?.value || ''
      const variant = form.querySelector('[name="id"]')?.value || ''
      configuration.value = JSON.stringify({
        version: 1,
        product: section.dataset.productTitle || '',
        variant,
        technique,
        front: sides.front.file ? { x: sides.front.x, y: sides.front.y, width: sides.front.width } : null,
        back: sides.back.file ? { x: sides.back.x, y: sides.back.y, width: sides.back.width } : null
      })
    })

    renderSide()
    if (window.gsap) {
      window.gsap.from(stage, { opacity: 0, scale: 0.94, duration: 0.8, ease: 'power3.out' })
      window.gsap.from(section.querySelectorAll('.product-customizer__control'), { opacity: 0, y: 18, duration: 0.5, stagger: 0.06, ease: 'power2.out' })
    }
  })
}

initialiseProductCustomizers()
document.addEventListener('shopify:section:load', (event) => initialiseProductCustomizers(event.target))
